import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'site-visit-send-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './site-visit-send-dialog.component.html',
  styleUrl: './site-visit-send-dialog.component.scss',
})
export class SiteVisitSendDialogComponent {
  _active: boolean = false;
  @Input() set active(value: boolean) {
    this._active = value;
    if (value) this.isSubmitting = false;
  }
  get active() { return this._active; }

  @Input() siteType: string = '';
  @Input() siteSubType: string = '';
  @Input() address: any = { streetAddress: '', cityStateZip: '' };

  @Output() modalClosed = new EventEmitter<boolean>();
  @Output() submitDates = new EventEmitter<any>();

  isSubmitting = false;

  submit() {
    this.isSubmitting = true;
    this.active = false;
    this.submitDates.emit();
  }

  closeDialog() {
    this.active = false;
    this.modalClosed.emit(this.active);
  }
}
